import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Collapse, Card } from "react-bootstrap";
// import generalInfo from "../../files/General_en.json";
// import SdIn from "./sd_in";
// import SdTitle from "./sd_title";
import PtIn from "./pt_in";
import PtTitle from "./pt_title";
// import ClassesIn from "./classes_in";
// import ClassesHeader from "./classes_header";
import CoursesIn from "./courses_in";
import CoursesTitle from "./courses_title";

const Home_Sections = () => {

  // const [openCl, setOpenCl] = useState(false);
  // const [textCl, setTextCl] = useState("More");
  // const [showCl, setShowCl] = useState(false);
  // const handleShowCl = () => setShowCl(true);
  // function handleCl() {
  //   setOpenCl(!openCl);
  //   if (!openCl ? setTextCl("Less") : setTextCl("More"));
  // }

  // const [openSd, setOpenSd] = useState(false);
  // const [textSd, setTextSd] = useState("More");
  // const [showSd, setShowSd] = useState(false);
  // const handleShowSd = () => setShowSd(true);
  // function handleSd() {
  //   setOpenSd(!openSd);
  //   if (!openSd ? setTextSd("Less") : setTextSd("More"));
  // }

  const [openPt, setOpenPt] = useState(false);
  const [textPt, setTextPt] = useState("More");
  // const [showPt, setShowPt] = useState(false);
  // const handleShowPt = () => setShowPt(true);
  function handlePt() {
    setOpenPt(!openPt);
    if (!openPt ? setTextPt("Less") : setTextPt("More"));
  }

  const [openCo, setOpenCo] = useState(false);
  const [textCo, setTextCo] = useState("More");
  // const [showCo, setShowCo] = useState(false);
  // const handleShowCo = () => setShowCo(true);
  function handleCo() {
    setOpenCo(!openCo);
    if (!openCo ? setTextCo("Less") : setTextCo("More"));
  }

  // function handleCloseCl() {
  //   setOpenCl(false);
  //   setTextCl("More");
  //   // window.scrollTo({ top: 180, left: 0, behavior: "auto" });
  // }

  // function handleCloseSd() {
  //   setOpenSd(false);
  //   setTextSd("More");
  //   // window.scrollTo(180, 0);
  // }

  // function handleCloseCo() {
  //   setOpenCo(false);
  //   setTextCo("More");
  //   // window.scrollTo(80, 0);
  // }

  // function handleClosePt() {
  //   setOpenPt(false);
  //   setTextPt("More");
  //   // window.scrollTo({ top: 180, left: 0, behavior: "auto" });
  // }

  function scrollToSection(id) {
    const element = document.getElementById(id);
    const headerOffset = 80;

    const y =
      element.getBoundingClientRect().top + window.pageYOffset - headerOffset;

    // if (id === "CL") {
    //   setOpenCl(false);
    //   setTextCl("More");
    // }
    // if (id === "SD") {
    //   setOpenSd(false);
    //   setTextSd("More");
    // }

    if (id === "PT") {
      setOpenPt(false);
      setTextPt("More");
    }

    if (id === "CO") {
      setOpenCo(false);
      setTextCo("More");
    }

    window.scrollTo({
      top: y,
      behavior: "smooth",
    });
  }

  // const ClassesInfo = ({ Id }) => {
  //   return (
  //     <>
  //       <div className="col-md-3 text-center" id={Id}>
  //         <h3 className="fw-bold">Classes</h3>
  //         <Link
  //           to="#classes"
  //           className="btn btn-danger"
  //           onClick={() => handleCl()}
  //         >
  //           <i>Read {textCl}</i>
  //         </Link>
  //         <br />
  //         <br />
  //       </div>
  //       <Collapse in={openCl}>
  //         <Card className="mt-3 retrobg">
  //           <Card.Body>
  //             <ClassesHeader />
  //             <div className="text-left">
  //               <ClassesIn />
  //             </div>
  //             <Link
  //               to="#"
  //               className="btn btn-link"
  //               onClick={() => scrollToSection(Id)}
  //             >
  //               <i>Close</i>
  //             </Link>
  //           </Card.Body>
  //         </Card>
  //       </Collapse>
  //     </>
  //   );
  // };

  // const SdInfo = ({ Id }) => {
  //   return (
  //     <>
  //       <div className="col-md-3 text-center" id={Id}>
  //         <h3 className="fw-bold">Self Defence</h3>
  //         <Link to="#Sd" className="btn btn-danger" onClick={() => handleSd()}>
  //           <i>Read {textSd}</i>
  //         </Link>
  //         <br />
  //         <br />
  //       </div>
  //       <Collapse in={openSd}>
  //         <Card className="mt-3 retrobg">
  //           <Card.Body>
  //             <SdTitle />
  //             <div className="text-left">
  //               <SdIn />
  //             </div>
  //             <Link
  //               to="#"
  //               className="btn btn-link"
  //               onClick={() => scrollToSection(Id)}
  //             >
  //               <i>Close</i>
  //             </Link>
  //           </Card.Body>
  //         </Card>
  //       </Collapse>
  //     </>
  //   );
  // };

  const PtInfo = ({ Id }) => {
    return (
      <>
        <div className="text-center" id={Id}>
          {/* <h3 className="fw-bold">Personal Training</h3> */}
          <Link to="#Pt" className="btn btn-danger" onClick={() => handlePt()}>
            <i>Read {textPt}</i>
          </Link>
          <br />
          <br />
        </div>
        <Collapse in={openPt}>
          <Card className="mt-3 retrobg">
            <Card.Body>
              <PtTitle />
              <div className="text-left">
                <PtIn />
              </div>
              <Link
                to="#"
                className="btn btn-link"
                onClick={() => scrollToSection(Id)}
              >
                <i>Close</i>
              </Link>
            </Card.Body>
          </Card>
        </Collapse>
      </>
    );
  };

  const CoursesInfo = ({ Id }) => {
    return (
      <>
        <div className="text-center" id={Id}>
          {/* <h3 className="fw-bold">Courses</h3> */}
          <Link to="#co" className="btn btn-danger" onClick={() => handleCo()}>
            <i>Read {textCo}</i>
          </Link>
          <br />
          <br />
        </div>
        <Collapse in={openCo}>
          <Card className="mt-3 retrobg">
            <Card.Body>
              <CoursesTitle />
              <div className="text-left">
                <CoursesIn />
              </div>
              <Link
                to="#"
                className="btn btn-link"
                onClick={() => scrollToSection(Id)}
              >
                <i>Close</i>
              </Link>
            </Card.Body>
          </Card>
        </Collapse>
      </>
    );
  };

  return (
    <section className="infobg container py-5">
      <h2 className="text-center fw-bold mb-4">Our Classes</h2>
      <div className="row">
        {[
          [
            "Adults'",
            "(AGE 14 AND OVER)",
            "Acton",
            "./img/lkbx_cl1.jpg",
            "Twyford Sports Centre",
            "Twyford Crescent, W3 9PP",
            "(10 minutes walk from Acton Town Tube)",
            "Train at all/any classes",
            "for £59.50 per month",
          ],
          [
            "Adults'",
            "(AGE 14 AND OVER)",
            "Chiswick",
            "./img/lkbx_cl2.jpg",
            "Arts Educational Schools",
            "14 Bath Road W4 1LY",
            "(3 minutes walk from Turnham Green Tube)",
            "Train at all/any classes",
            "for £59.50 per month",
          ],
          [
            "Children's",
            "(AGE 6 to 13)",
            "Acton",
            "./img/lkbx_cl6.jpg",
            "Twyford Sports Centre",
            "Twyford Crescent, W3 9PP",
            "(10 minutes walk from Acton Town Tube)",
            "Train at all/any classes",
            "for £59.50 per month",
          ],
          [
            "Children's",
            "(AGE 6 to 13)",
            "Chiswick",
            "./img/lkbx_cl5.jpg",
            "Arts Educational Schools",
            "14 Bath Road W4 1LY",
            "(3 minutes walk from Turnham Green Tube)",
            "Train at all/any classes",
            "for £59.50 per month",
          ],
        ].map((item, i) => (
          <div className="col-md-3 mb-4" key={i}>
            <div className="card bg-dark text-white border-secondary">
              <img src={item[(i, 3)]} className="card-img-top" alt="class"/>
              <div className="card-body">
                <h3 className="card-title text-center">{item[(i, 0)]}</h3>
                <h6 className="card-title text-center">{item[(i, 1)]}</h6>
                <h5 className="card-title text-center">{item[(i, 2)]}</h5>
                <h6 className="card-title text-center">{item[(i, 4)]}</h6>
                <h6 className="card-title text-center">{item[(i, 5)]}</h6>
                <p className="card-title text-center">{item[(i, 6)]}</p>
                <p className="card-title text-center">
                  {item[(i, 7)]}
                  <br />
                  {item[(i, 8)]}
                </p>
              </div>
              <a
                href="https://www.fastdd.co.uk/platinum/start.php?c=London-Kickboxing"
                target="_blank"
                rel="noreferrer"
                title="FastDD Online Direct Debit Portal"
                className="btn btn-danger"
                role="button"
              >
                &nbsp;Join Now&nbsp;
              </a>                  
            </div>         
          </div>
        ))}       
      </div>

      <div className="row">
        {[
          [
            "Personal Training",
            "(AGE 6 and OVER)",
            "",
            "",
            "",
            "",
            "London Kickboxing",
            "also offers personal training, one-to-one or two-to-one. Train at the gym/studios we use in Kensington or at a venue of your choice, i.e. home, work, local park, gym etc.",
            "",
          ],
          [
            "Courses",
            "(AGE 18 and OVER)",
            "",
            "",
            "",
            "",
            "London Kickboxing",
            "periodically runs courses and seminars in self-defence, nunchaku, stick, other martial arts weapons and related activities",
            "",
          ],
        ].map((item, i) => (
          <div className="col-md-3 mb-4" key={i}>
            <div className="card bg-dark text-white border-secondary">
              {/* <img src={item[(i, 3)]} className="card-img-top" alt="class" /> */}
              <div className="card-body">
                <h3 className="card-title text-center">{item[(i, 0)]}</h3>
                <h6 className="card-title text-center">{item[(i, 1)]}</h6>
                <h5 className="card-title text-center">{item[(i, 2)]}</h5>
                <h6 className="card-title text-center">{item[(i, 4)]}</h6>
                <h6 className="card-title text-center">{item[(i, 5)]}</h6>
                <p className="card-title text-center">
                  <strong>{item[(i, 6)]}</strong>
                  <br />
                  {item[(i, 7)]}
                </p>
                <p className="card-title text-center">{item[(i, 8)]}</p>
              </div>
                {i === 0 ? <PtInfo Id="PT" /> : null}
                {i === 1 ? <CoursesInfo Id="CO" /> : null}              
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Home_Sections;
